import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Region } from '@cod-monorepo/interfaces';

@Component({
    selector: 'app-region-select',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './region-select.component.html'
})
export class RegionSelectComponent {
    @Input({ required: true }) region: string | null = null;
    public regions = Region;
}
